import { useState } from 'react';
import {
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';

export default function ReportPage() {
  const [reportType, setReportType] = useState('');
  const [deviceCode, setDeviceCode] = useState('');
  const [reportData, setReportData] = useState([]);

  const handleGetReport = () => {
    console.log('Fetching report:', reportType, deviceCode);
    if (
        (reportType === 'device_signal_info' && deviceCode === '') ||
        (reportType === 'device_battery_status' && deviceCode === '')
      ) {
        alert('Please enter a Device Code first!');
        return;
      }

    setReportData([
      { status: 'sos_alarm', time: '07/03/2025, 07:51:13' },
      { status: 'sos_alarm', time: '07/03/2025, 05:25:35' },
      { status: 'sos_alarm', time: '06/03/2025, 09:04:02' },
    ]);
  };

  const downloadPDF = () => {
    console.log('Downloading PDF...');
  };

  const downloadExcel = () => {
    console.log('Downloading Excel...');
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* Top Controls */}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 2,
          backgroundColor: '#f9f9f9',
          p: 1,
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        {/* Report Select */}
        <Box sx={{ minWidth: 200 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Select Report</InputLabel>
            <Select
              value={reportType}
              label="Select Report"
              onChange={(e) => {
                setReportType(e.target.value);
                setReportData([]); // Clear previous report
                setDeviceCode(''); // Clear previous device code
              }}
            >
              <MenuItem value="">
                <em>Select an option</em>
              </MenuItem>
              <MenuItem value="device_signal_info">Device Signal Info</MenuItem>
              <MenuItem value="device_battery_status">Device Battery Status</MenuItem>
              <MenuItem value="exception_report">Exception Report</MenuItem>
              <MenuItem value="todays_device_status">Today's Device Status</MenuItem>
              <MenuItem value="device_on_off_status">Device ON OFF Status</MenuItem>
              <MenuItem value="count_status_report">Count Status Report</MenuItem>
              <MenuItem value="division_status_report">Division Status Report</MenuItem>
              <MenuItem value="monitor_sos_press">Monitor SOS Press</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Device Code input: only if "device_signal_info" selected */}

{(reportType === 'device_signal_info' || reportType === 'device_battery_status') && (
  <Box sx={{ minWidth: 200 }}>
    <TextField
      label="Device Code"
      variant="outlined"
      size="small"
      fullWidth
      value={deviceCode}
      onChange={(e) => setDeviceCode(e.target.value)}
    />
  </Box>
)}

        {/* Buttons */}
        <Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleGetReport}
          >
            Get Report
          </Button>
        </Box>

        <Box>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<PictureAsPdfIcon />}
            onClick={downloadPDF}
          >
            PDF
          </Button>
        </Box>

        <Box>
          <Button
            variant="contained"
            color="success"
            size="small"
            startIcon={<DescriptionIcon />}
            onClick={downloadExcel}
          >
            Excel
          </Button>
        </Box>
      </Box>

      {/* Table Section */}
      {reportData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Device Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>{row.time}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
          No report data available.
        </Typography>
      )}
    </Box>
  );
}
